import ListItemMovieContainer from '../../DragAndDropItems/cont/ListItemMovieContainer'
import { MOVIE } from '../../../constants/itemTypes'

const CheckboxMovieItem = ({
    field: { name, value, onChange, onBlur },
    id,
    movie,
    additionalClass=false,
    pathnameEdit=false
}) => {
    const isSelected = _.contains(value, id)

    return (
        <div className="movie-item-radio-wrapper">
            <label className="control control-radio" htmlFor={id}>
                <input
                    name={name}
                    id={id}
                    type="checkbox"
                    value={id}
                    checked={isSelected}
                    onChange={val => onChange(val, name)}
                    onBlur={onBlur}
                    className={'radio-button'}
                />

                <ListItemMovieContainer
                    itemType={MOVIE}
                    itemData={movie}
                    additionalClass={additionalClass}
                    isSelected={isSelected}
                    pathnameEdit={pathnameEdit}
                />
                
            </label>
        </div>
    )
}

export default CheckboxMovieItem